import { render, staticRenderFns } from "./Kontak.vue?vue&type=template&id=75d38dc1&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.1_mi7kfaeh4nmupiqclubmvzt3ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WhatsappButton: require('/opt/buildhome/repo/components/WhatsappButton.vue').default})
